import { 
    AUTOCALL_RENDEMENT_firstPayoffInfo, 
    AUTOCALL_RENDEMENT_secondPayoffInfo, 
    AUTOCALL_RENDEMENT_thirdPayoffInfo,
    AUTOCALL_RENDEMENT_fourthPayoffInfo, 
    AUTOCALL_RENDEMENT_fifthPayoffInfo 
} from "src/shared/Cotation/describe/AutocallRendement"
import { AUTOCALL_RENDEMENT_default } from "src/shared/Cotation/chart/data/default/AutocallRendement"
import { checkExistValuesForm } from "src/shared/utils/helpers"
import { ProdcutType } from "src/type/product"
import { CHART_STYLES } from "./config/ChartStyles"
import { axisConfig } from "./config/AxisConfig"

const styles = CHART_STYLES[ProdcutType.AUTOCALL_RENDEMENT]

const defaultConfig = axisConfig("Niveau du sous-jacent", "Coupon", true, true) 

const AUTOCALL_RENDEMENT_firstPayoff_chart = form => ([
    {
        type: "line",
        key: "coupon-garanti",           
        data: [
            {x: 0, y: form.coupon_garanti}, 
            {x: 5, y: form.coupon_garanti}
        ],            
        color: styles.rendement.color, 
        strokeWidth: styles.rendement.strokeWidth, 
    },
    {
        type: "line",
        key: "support-1",    
        data: [
            {x: 0, y: form.coupon_garanti - 5}, 
            {x: 5, y: form.coupon_garanti - 5}
        ],                       
        strokeWidth: 0
    },
    {
        type: "line",
        key: "support-0",     
        data: [
            {x: 0, y: form.coupon_garanti + 5}, 
            {x: 5, y: form.coupon_garanti + 5}
        ],                
        strokeWidth: 0
    },
    {
        type: "point",
        key: "coupon-garanti-point",
        data: [
            {x: 0, y: form.coupon_garanti}
        ],
        color: styles.coupon_garanti.color,
        caption: `Coupon garanti : ${form.coupon_garanti}`
    }
])

const AUTOCALL_RENDEMENT_secondPayoff_chart = form => ([
    {
        type: "line",
        key: "coupon-maximum-line",
        data: [
            {x: form.seuil_autocall, y: form.coupon_conditionnel_maximum}, 
            {x: form.seuil_autocall*1.3, y: form.coupon_conditionnel_maximum}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth, 
    },
    {
        type: "line",
        key: "coupon-minimum-line",
        data: [
            {x: form.barriere_de_coupon_conditionnel_minimum, y: form.coupon_conditionnel_minimum}, 
            {x: form.seuil_autocall, y: form.coupon_conditionnel_minimum}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth, 
    },
    {
        type: "line",
        key: "seuil-autocall-line",
        data: [
            {x: form.seuil_autocall, y: form.coupon_conditionnel_minimum},
            {x: form.seuil_autocall, y: form.coupon_conditionnel_maximum}
        ],
        color: styles.rendement.color,
        strokeDasharray: styles.rendement.strokeDasharray,
    },
    {
        type: "line",
        key: "barriere-coupon-line",
        data: [
            {x: form.barriere_de_coupon_conditionnel_minimum, y: 0}, 
            {x: form.barriere_de_coupon_conditionnel_minimum, y: form.coupon_conditionnel_minimum}
        ],
        color: styles.rendement.color,
        strokeDasharray: styles.rendement.strokeDasharray,
    },
    {
        type: "line",
        key: "coupon-to-barriere",
        data: [
            {x: 0, y: 0}, 
            {x: form.barriere_de_coupon_conditionnel_minimum, y: 0}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth, 
    },
    
    {
        type: "point",
        key: "coupon-maximum-point",
        data: [
            {x: 0, y: form.coupon_conditionnel_maximum}
        ],
        color: styles.coupon_conditionnel_maximum.color,
        caption: `Coupon conditionnel maximum :  ${form.coupon_conditionnel_maximum}` 
    },
    {
        type: "point",
        key: "coupon-minimum-point",
        data: [
            {x: 0, y: form.coupon_conditionnel_minimum}
        ],
        color: styles.coupon_conditionnel_minimum.color,
        caption: `Coupon conditionnel minimum : ${form.coupon_conditionnel_minimum}`
    },
    {
        type: "point",
        key: "seuil-autocall-point",
        data: [
            {x: form.seuil_autocall, y: 0}
        ],
        color: styles.seuil_autocall.color,
        caption: `Seuil autocall : ${form.seuil_autocall}`
    },
    {
        type: "point",
        key: "barriere-coupon-point",
        data: [
            {x: form.barriere_de_coupon_conditionnel_minimum, y: 0}
        ],
        color: styles.barriere_de_coupon_conditionnel_minimum.color,
        caption: `Barrière de coupon conditionnel minimum : ${form.barriere_de_coupon_conditionnel_minimum}`
    },
])

const AUTOCALL_RENDEMENT_thirdPayoff_chart = form => ([
    {
        type: "line",
        key: "coupon-maximum-line",
        data: [
            {x: form.seuil_autocall, y: form.coupon_conditionnel_maximum}, 
            {x: form.seuil_autocall*1.3, y: form.coupon_conditionnel_maximum}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth, 
    },
    {
        type: "line",
        key: "seuil-autocall-line",
        data: [
            {x: form.seuil_autocall, y: 0}, 
            {x: form.seuil_autocall, y: form.coupon_conditionnel_maximum}
        ],
        color: styles.rendement.color,
        strokeDasharray: styles.rendement.strokeDasharray, 
    },
    {
        type: "line",
        key: "coupon-to-seuil-autocall",
        data: [
            {x: 0, y: 0}, 
            {x: form.seuil_autocall, y: 0}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth,
    },
    {
        type: "point",
        key: "coupon-maximum-point",
        data: [
            {x: 0, y: form.coupon_conditionnel_maximum}, 
        ],
        color: styles.coupon_conditionnel_maximum.color,
        caption: `Coupon conditionnel maximum : ${form.coupon_conditionnel_maximum}`
    },
    {
        type: "point",
        key: "seuil-autocall-point",
        data: [
            {x: form.seuil_autocall, y: 0}, 
        ],
        color: styles.seuil_autocall.color,
        caption: `Seuil d’autocall : ${form.seuil_autocall}`
    },
])

const AUTOCALL_RENDEMENT_fourthPayoff_chart = form => ([
    {
        type: "line",
        key: "coupon-maximum-line",
        data: [
            {x: form.seuil_autocall, y: form.coupon_conditionnel_maximum}, 
            {x: form.seuil_autocall*1.3, y: form.coupon_conditionnel_maximum}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth,
    },
    {
        type: "line",
        key: "coupon-minimum-line",
        data: [
            {x: form.barriere_de_coupon_conditionnel_minimum, y: form.coupon_conditionnel_minimum}, 
            {x: form.seuil_autocall, y: form.coupon_conditionnel_minimum}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth,
    },
    {
        type: "line",
        key: "seuil-autocall",
        data: [
            {x: form.seuil_autocall, y: form.coupon_conditionnel_minimum}, 
            {x: form.seuil_autocall, y: form.coupon_conditionnel_maximum}
        ],
        strokeDasharray: [7, 4],
        color: styles.rendement.color,
    },
    {
        type: "line",
        key: "barriere-coupon-line",
        data: [
            {x: form.barriere_de_coupon_conditionnel_minimum, y: 0}, 
            {x: form.barriere_de_coupon_conditionnel_minimum, y: form.coupon_conditionnel_minimum}
        ],
        color: styles.rendement.color,
        strokeDasharray: styles.rendement.strokeDasharray,
    },
    {
        type: "line",
        key: "seuil-autocall-line",
        data: [
            {x: form.barriere_de_protection_du_capital, y: 0}, 
            {x: form.barriere_de_protection_du_capital, y: -(form.barriere_de_coupon_conditionnel_minimum-form.barriere_de_protection_du_capital)* 0.1}
        ],
        color: styles.rendement.color,
        strokeDasharray: styles.rendement.strokeDasharray,
    },
    {
        type: "line",
        key: "coupon-to-barriere-line",
        data: [
            {x: (form.barriere_de_protection_du_capital)* 0.67, y:  -0.33 * (form.coupon_conditionnel_maximum / (form.seuil_autocall - form.barriere_de_protection_du_capital)) * form.barriere_de_protection_du_capital}, 
            {x: form.barriere_de_protection_du_capital, y: -(form.barriere_de_coupon_conditionnel_minimum-form.barriere_de_protection_du_capital)* 0.1}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth,
    }, 
    {
        type: "line",
        key: "protection-to-coupon",
        data: [
            {x: form.barriere_de_protection_du_capital, y: 0}, 
            {x: form.barriere_de_coupon_conditionnel_minimum, y: 0}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth,
    },
    {
        type: "point",
        key: "barriere-coupon-point",
        data: [
            {x: form.barriere_de_coupon_conditionnel_minimum, y: 0}
        ],
        color: styles.barriere_de_coupon_conditionnel_minimum.color,
        caption: `Barrière de coupon conditionnel minimum : ${form.barriere_de_coupon_conditionnel_minimum}`
    },
    {
        type: "point",
        key: "coupon-maximum-point",
        data: [
            {x: 0, y: form.coupon_conditionnel_maximum}
        ],
        color: styles.coupon_conditionnel_maximum.color,
        caption: `Coupon conditionnel maximum : ${form.coupon_conditionnel_maximum}`
    },
    {
        type: "point",
        key: "coupon-minimum-point",
        data: [
            {x: 0, y: form.coupon_conditionnel_minimum}
        ],
        color: styles.coupon_conditionnel_minimum.color,
        caption: `Coupon conditionnel minimum : ${form.coupon_conditionnel_minimum}`
    },
    {
        type: "point",
        key: "coupon-to-barriere-point",
        data: [
            {x: form.barriere_de_protection_du_capital, y: 0}
        ],
        color: styles.barriere_de_protection_du_capital.color,
        caption: `Barrière de protection du capital : ${form.barriere_de_protection_du_capital}`
    }, 
    {
        type: "point",
        key: "seuil-autocall-point",
        data: [
            {x: form.seuil_autocall, y: 0}, 
        ],
        color: styles.seuil_autocall.color,
        caption: `Seuil d’autocall : ${form.seuil_autocall}`
    },
])

const AUTOCALL_RENDEMENT_fifthPayoff_chart = form => ([
    {
        type: "line",
        key: "coupon-maximum-line",
        data: [
            {x: form.seuil_autocall, y: form.coupon_conditionnel_maximum}, 
            {x: form.seuil_autocall*1.3, y: form.coupon_conditionnel_maximum}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth,
    },
    {
        type: "line",
        key: "seuil-autocall-line",
        data: [
            {x: form.seuil_autocall, y: 0}, 
            {x: form.seuil_autocall, y: form.coupon_conditionnel_maximum}
        ],
        color: styles.rendement.color,
        strokeDasharray: styles.rendement.strokeDasharray,
    },
    {
        type: "line",
        key: "barriere-to-seuil-autocall-line",
        data: [
            {x: form.barriere_de_protection_du_capital, y: 0}, 
            {x: form.seuil_autocall, y: 0}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth,
    },
    {
        type: "line",
        key: "barriere-line-support",
        data: [
            {x: form.barriere_de_protection_du_capital, y: 0}, 
            {x: form.barriere_de_protection_du_capital, y: -(form.barriere_de_coupon_conditionnel_minimum-form.barriere_de_protection_du_capital)* 0.1}
        ],
        color: styles.rendement.color,
        strokeDasharray: styles.rendement.strokeDasharray,
    },
    {
        type: "line",
        key: "coupon-to-barriere",
        data: [
            {x: (form.barriere_de_protection_du_capital)* 2/3, y: -0.33 * (form.coupon_conditionnel_maximum / (form.seuil_autocall - form.barriere_de_protection_du_capital)) * form.barriere_de_protection_du_capital}, 
            {x: form.barriere_de_protection_du_capital, y: -(form.barriere_de_coupon_conditionnel_minimum-form.barriere_de_protection_du_capital)* 0.1}
        ],
        color: styles.rendement.color,
        strokeWidth: styles.rendement.strokeWidth,
    },
    {
        type: "point",
        key: "coupon-maximum-point",
        data: [
            {x: 0, y: form.coupon_conditionnel_maximum}
        ],
        color: styles.coupon_conditionnel_maximum.color,
        caption: `Coupon conditionnel maximum : ${form.coupon_conditionnel_maximum}`
    },
    {
        type: "point",
        key: "seuil-autocall-point",
        data: [
            {x: form.seuil_autocall, y: 0}, 
        ],
        color: styles.seuil_autocall.color,
        caption: `Seuil d’autocall : ${form.seuil_autocall}`
    },
    {
        type: "point",
        key: "barriere-to-seuil-autocall-point",
        data: [
            {x: form.barriere_de_protection_du_capital, y: 0}, 
        ],
        color: styles.barriere_de_protection_du_capital.color,
        caption: `Barrière de protection du capital : ${form.barriere_de_protection_du_capital}`
    },
])

export const AUTOCALL_RENDEMENT_data = (form) => ([
    {
        option: "2",
        label: 'Profil de rendement à chaque date de constatation intermédiaire du niveau du sous-jacent (en dehors des périodes de coupon garanti)',
        chart: AUTOCALL_RENDEMENT_secondPayoff_chart(form),
        chartDefault: AUTOCALL_RENDEMENT_secondPayoff_chart(AUTOCALL_RENDEMENT_default[1]),
        describe: AUTOCALL_RENDEMENT_secondPayoffInfo(form),
        legends: {
            lines: [
                {title: "Rendement",                                color: styles.rendement.color, strokeWidth: styles.rendement.strokeWidth}
            ],
            points: [
                {title: "Coupon conditionnel maximum",              color: styles.coupon_conditionnel_maximum.color},
                {title: "Coupon conditionnel minimum",              color: styles.coupon_conditionnel_minimum.color},
                {title: "Seuil autocall",                           color: styles.seuil_autocall.color},
                {title: "Barrière de coupon conditionnel minimum",  color: styles.barriere_de_coupon_conditionnel_minimum.color}
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["barriere_de_protection_du_capital", "seuil_autocall", "coupon_conditionnel_maximum", "coupon_conditionnel_minimum", "barriere_de_coupon_conditionnel_minimum", "coupon_garanti"]),
        isAvailable: form.barriere_de_coupon_conditionnel_minimum !== undefined
    },
    {
        option: "3",
        label: 'Profil de rendement à chaque date de constatation intermédiaire du niveau du sous-jacent (en dehors des périodes de coupon garanti)',
        chart: AUTOCALL_RENDEMENT_thirdPayoff_chart(form),
        chartDefault: AUTOCALL_RENDEMENT_thirdPayoff_chart(AUTOCALL_RENDEMENT_default[2]),
        describe: AUTOCALL_RENDEMENT_thirdPayoffInfo(form),
        legends: {
            lines: [
                {title: "Rendement",                    color: styles.rendement.color, strokeWidth: styles.rendement.color}
            ],
            points: [
                {title: "Coupon conditionnel maximum",  color: styles.coupon_conditionnel_maximum.color},
                {title: "Seuil d’autocall",             color: styles.seuil_autocall.color}
            ],
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["barriere_de_protection_du_capital", "seuil_autocall", "coupon_conditionnel_maximum", "coupon_conditionnel_minimum", "barriere_de_coupon_conditionnel_minimum", "coupon_garanti"]),
        isAvailable: form.barriere_de_coupon_conditionnel_minimum === undefined
    },
    {
        option: "4",
        label: 'Profil de rendement à la date de constatation finale du niveau du sous-jacent',
        chart: AUTOCALL_RENDEMENT_fourthPayoff_chart(form),
        chartDefault: AUTOCALL_RENDEMENT_fourthPayoff_chart(AUTOCALL_RENDEMENT_default[3]),
        describe: AUTOCALL_RENDEMENT_fourthPayoffInfo(form),
        legends: {
            lines: [
                {title: "Rendement",                                color: styles.rendement.color, strokeWidth: styles.rendement.strokeWidth}
            ],
            points: [
                {title: "Coupon conditionnel maximum",              color: styles.coupon_conditionnel_maximum.color},
                {title: "Coupon conditionnel minimum",              color: styles.coupon_conditionnel_minimum.color},
                {title: "Barrière de coupon conditionnel minimum",  color: styles.barriere_de_coupon_conditionnel_minimum.color},
                {title: "Barrière de protection du capital",        color: styles.barriere_de_protection_du_capital.color},
                {title: "Seuil autocall",                           color: styles.seuil_autocall.color}
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["barriere_de_protection_du_capital", "seuil_autocall", "coupon_conditionnel_maximum", "coupon_conditionnel_minimum", "barriere_de_coupon_conditionnel_minimum", "coupon_garanti"]),
        isAvailable: form.barriere_de_coupon_conditionnel_minimum !== undefined
    },
    {
        option: "5",
        label: 'Profil de rendement à la date de constatation finale du niveau du sous-jacent',
        chart: AUTOCALL_RENDEMENT_fifthPayoff_chart(form),
        chartDefault: AUTOCALL_RENDEMENT_fifthPayoff_chart(AUTOCALL_RENDEMENT_default[4]),
        describe: AUTOCALL_RENDEMENT_fifthPayoffInfo(form),
        legends: {
            lines: [
                {title: "Rendement",                            color: styles.rendement.color, strokeWidth: styles.rendement.strokeWidth}
            ],
            points: [
                {title: "Coupon conditionnel maximum",          color: styles.coupon_conditionnel_maximum.color},
                {title: "Seuil d’autocall",                     color: styles.seuil_autocall.color},
                {title: "Barrière de protection du capital",    color: styles.barriere_de_protection_du_capital.color}
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["barriere_de_protection_du_capital", "seuil_autocall", "coupon_conditionnel_maximum", "coupon_conditionnel_minimum", "barriere_de_coupon_conditionnel_minimum", "coupon_garanti"]),
        isAvailable: form.barriere_de_coupon_conditionnel_minimum === undefined
    },
    {
        option: "1",
        label: 'Profil de rendement pour une période avec un coupon garanti',
        chart: AUTOCALL_RENDEMENT_firstPayoff_chart(form),
        chartDefault: AUTOCALL_RENDEMENT_firstPayoff_chart(AUTOCALL_RENDEMENT_default[0]),
        describe: AUTOCALL_RENDEMENT_firstPayoffInfo(form),
        legends: {
            lines: [
                {title: "Rendement",        color: styles.rendement.color, strokeWidth: styles.rendement.strokeWidth}
            ],
            points: [
                {title: "Coupon garanti",   color: styles.coupon_garanti.color}
            ]
        },
        config: {
            ...axisConfig("Niveau du sous-jacent", "Coupon", false, true)
        },
        condition: checkExistValuesForm(form, ["barriere_de_protection_du_capital", "seuil_autocall", "coupon_conditionnel_maximum", "coupon_conditionnel_minimum", "barriere_de_coupon_conditionnel_minimum", "coupon_garanti"]),
        isAvailable: !!form.nombre_de_periodes_avec_un_coupon_garanti && form.nombre_de_periodes_avec_un_coupon_garanti > 0
    },
])


// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/AutocallRendement.tsx